export default __webpack_public_path__ + "static/VehiclesBasicWithAction-4b96beca79192db2163b6cff0e9fa20b.jpg";